import type { ConnectionState } from "@/types";
import type { BabyDeviceInfo } from "./types";

export function monitoringStatus(state: ConnectionState, hasVideo: boolean) {
  if (state === "connected") return hasVideo ? "Live video" : "Live audio";
  if (state === "connecting") return "Connecting…";
  return "Connection interrupted";
}

/** Audio levels from the controller are percentages, not a 0–1 fraction. */
export function audioFraction(level: number) {
  return Number.isFinite(level) ? Math.min(100, Math.max(0, level)) / 100 : 0;
}

export function streamAction(baby: BabyDeviceInfo) {
  if (baby.cameraActive) return "Watch Now";
  if (baby.micActive) return "Listen Now";
  return "Waiting for stream";
}

export function streamingFirst(devices: BabyDeviceInfo[]) {
  return [...devices].sort(
    (a, b) =>
      Number(b.cameraActive || b.micActive) -
      Number(a.cameraActive || a.micActive),
  );
}
